import { InboundFax } from "./inboundFax";

export class InboundFaxData {
    faxes!: InboundFax[];
    rowCount!: number;
    uniqueValues!: string;
    agingCount!: number;
  }